import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import notify from './notifications-helper'
import './test-expo-push-notifications.scss'
import api from './api-client'
import { ExpoNotificationMessage, NotificationChannels } from '@ecountabl/lib'

const initialState = {
  visible: false,
  loading: false,
  // expo token fields
  recipients: '',
  messageTitle: '',
  messageBody: '',
  data: '',
  // ios
  messageSubtitle: '',
  badgeCount: 0,
  soundName: 'default',
  // android
  channelId: NotificationChannels.DEFAULT
}

export const TestExpoPushNotification = () => {
  const dispatch = useDispatch()
  const [state, setState] = useState(initialState)

  const openModal = () => {
    setState({
      ...state,
      visible: true
    })
  }

  const closeModal = () => {
    setState(initialState)
  }

  const sendNotification = async () => {
    setState({...state, loading: true})

    const message: ExpoNotificationMessage = {
      recipients: state.recipients.split(',').map(r => r.trim()),
      messageTitle: state.messageTitle,
      messageBody: state.messageBody,
      data: state.data,
      messageSubtitle: state.messageSubtitle,
      badgeCount: state.badgeCount,
      soundName: state.soundName,
      channelId: state.channelId
    }

    try {
      const results = await api.sendExpoNotification(message)

      const successes = results.filter(r => r.success)

      dispatch(notify.success({
        message: `Push notification sent to ${successes.length} of ${message.recipients.length} recipient${message.recipients.length === 1 ? '' : 's'}`,
        autoDismiss: 20
      }))
    } catch (ex) {
      dispatch(notify.error({
        message: `Error sending notification: ${ex.message}`,
        autoDismiss: 20
      }))
    } finally {
      setState({...state, loading: false})
      closeModal()
    }
  }

  return <>
    <button
      type="button"
      className="btn btn-danger"
      onClick={openModal}
    >
      Test Expo Push Notification
    </button>
    <div
        className='central-modal'
        style={{display: state.visible ? 'flex' : "none"}}
        onPointerDown={closeModal}
      >
        <div
          className='modal-content'
          onPointerDown={(e) => e.stopPropagation()}
          onScroll={(e) => e.stopPropagation()}
        >
          <h1>Send Expo Push Notification</h1>
          <div>
            <p>Know before sending:</p>
            <ul>
              <li>Understand you are creating a push notification to send to users with expo push tokens specified below</li>
              <li>Only devices with expo push tokens will receive the notification</li>
              <li>Be sure to get confirmation this is a message you want to send before sending (you can't undo it)</li>
            </ul>
          </div>
          <div className='form-group'>
            <div className='form-group-input'>
              <label>Expo Tokens {`([<token>,<token>,...])`}</label>
              <textarea
                className='form-group-input'
                value={state.recipients}
                onChange={e => setState({...state, recipients: e.target.value})}
                placeholder='[token1,token2,token3,...]'
              />
            </div>
            <div className='form-group-input'>
              <label>Title (optional : default is "Impact Banking")</label>
              <input
                type="text"
                value={state.messageTitle}
                onChange={e => setState({...state, messageTitle: e.target.value})}
                placeholder='Impact Banking'
              />
            </div>
            <div className='form-group-input'>
              <label>Message (required)</label>
              <input
                type="text"
                value={state.messageBody}
                onChange={e => setState({...state, messageBody: e.target.value})}
              />
            </div>
            <div className='form-group-input'>
              <label>Data (JSON string, optional)</label>
              <textarea
                value={state.data}
                onChange={e => setState({...state, data: e.target.value})}
                placeholder='{"key": "value"}'
              />
            </div>
            
            <div className='device-section'>
              <h3>iOS</h3>
              <div className='form-group-input'>
                <label>Subtitle (optional)</label>
                <input
                  type="text"
                  value={state.messageSubtitle}
                  onChange={e => setState({...state, messageSubtitle: e.target.value})}
                  placeholder='Optional subtitle'
                />
              </div>
              <div className='form-group-input'>
                <label>Sound (optional : default is "default")</label>
                <select
                  value={state.soundName}
                  onChange={e => setState({...state, soundName: e.target.value})}
                >
                  <option value="default">Default</option>
                  <option value="none">None</option>
                </select>
              </div>
              <div className='form-group-input'>
                <label>Badge (optional : default is "true")</label>
                <input
                  type="number"
                  value={state.badgeCount}
                  onChange={e => setState({...state, badgeCount: Math.max(0, parseInt(e.target.value))})}
                />
              </div>
            </div>

            <div className='device-section'>
              <h3>Android</h3>
              <div className='form-group-input'>
                <label>Channel ID (required)</label>
                <select
                  value={state.channelId}
                  onChange={e => setState({...state, channelId: e.target.value})}
                >
                  <option value={NotificationChannels.DEFAULT}>Default</option>
                  <option value={NotificationChannels.WARNING}>Warning</option>
                  <option value={NotificationChannels.URGENT}>Urgent</option>
                </select>
              </div>
            </div>
          </div>
          <div style={{display: "flex", flexDirection: "row", gap: "5em", margin: "2em 0 0 0"}}>
            <button className='btn btn-secondary' onClick={closeModal}>Close</button>
            <button
              className='btn btn-primary'
              onClick={sendNotification}
              disabled={state.loading}
            >
              Send Notification
            </button>
          </div>
        </div>
      </div>
  </>
}

export default TestExpoPushNotification
